import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Organization = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Organization' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M20,3 L20,23 L4,23 L4,3 L20,3 Z M8.042,9 L10.042,9 L10.042,7 L8.042,7 L8.042,9 Z M14,9 L16,9 L16,7 L14,7 L14,9 Z M8.042,15 L10.042,15 L10.042,13 L8.042,13 L8.042,15 Z M10.042,23 L14.042,23 L14.042,19 L10.042,19 L10.042,23 Z M14,15 L16,15 L16,13 L14,13 L14,15 Z M2,3 L22,3 L22,1 L2,1 L2,3 Z' />
  </StyledIcon>
);
